import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import {
  Figure,
  ScrollAnimation,
  ScrollAnimationWithEase,
  ScrollAnimationParent,
  ScrollAnimationChild,
} from '@studiometa/ui';
import { isDev } from './config.js';
import Navigation from './molecules/Navigation.js';
import ScrollReveal from './utils/ScrollReveal.js';
import Home from './organisms/Home.js';
import Project from './molecules/Project.js';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      ScrollAnimation,
      ScrollAnimationWithEase,
      ScrollReveal,
      ScrollAnimationParent,
      ScrollAnimationChild,
      Figure,
      Navigation,
      Home,
      Project,
      LargeText: (app) =>
        importWhenVisible(() => import('./molecules/LargeText.js'), 'LargeText', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
    },
  };

  /**
   * Change navigation item
   * @param  {object} target
   * @returns {void}
   */
  onHomeChangeNavigation(target) {
    this.$children.Navigation[0].setCurrentItem(target);
  }
}

export default createApp(App, document.body);
